import React from 'react';
import { ArrowForwardOutlined, Button } from '@landr/maestro';
import styled from 'styled-components';
import { Link, To } from 'react-router-dom';

export const CustomLinkButton = styled(Link)`
    &:hover {
        text-decoration: none;
    }
`;

const LinkWithArrow = ({ to, ctaCopy }: { to: To; ctaCopy: string }) => (
    <Button
        as={CustomLinkButton}
        to={to}
        kind="link"
        iconRight={ArrowForwardOutlined}
        variant="subtle"
    >
        {ctaCopy}
    </Button>
);

export default LinkWithArrow;
